import React, { useState } from "react";
import { CalendarView } from "./FullCalendar";
import { PlanningView } from "./PlanningViewComp";

export default function RdvContainer({ filteredPage, handleOpenModal }) {
  const [view, setView] = useState("planning"); // 'calendar' ou 'planning'

  return (
    <>
      <div className="mb-3">
        <button
          className={`btn me-2 ${
            view === "calendar" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setView("calendar")}
        >
          Vue Calendrier
        </button>
        <button
          className={`btn ${
            view === "planning" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setView("planning")}
        >
          Vue Planning
        </button>
      </div>

      {view === "calendar" ? (
        <CalendarView rdvs={filteredPage} onDeleteRequest={handleOpenModal} />
      ) : (
        <PlanningView rdvs={filteredPage} onDeleteRequest={handleOpenModal} />
      )}
    </>
  );
}
